import * as React from 'react';
import styles from './IframeDisplay.module.css';
import { BackButton } from './BackButton';

interface Props {
  url: string;
  onClose: () => void;
}

export const IframeDisplay = ({ url, onClose }: Props) => {
  return (
    <div className={styles['page-container']}>
      <BackButton onClick={onClose} />
      <iframe
        className={styles['iframe']}
        title="External Content"
        src={url}
        sandbox="allow-scripts allow-same-origin allow-forms allow-popups"
      />
    </div>
  );
};
